// 숫자·수리 영역 (총 20문항)

export const iqNumberQuestions = [
  {
    id: 33,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,1,1],[0,0,0],[0,0,0]],
        [[0,1,0],[0,1,0],[0,1,0]],
        null,
        [[0,0,0],[1,1,1],[0,0,0]],
        [[0,1,0],[0,1,0],[0,1,0]],
        null,
        [[0,0,0],[0,0,0],[1,1,1]],
        [[0,1,0],[0,1,0],[0,1,0]],
        null
      ]
    },
    options: ['1', '2', '3', '4'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1,0,1],[0,1,0],[0,1,0]] },
      { grid: [[0,1,0],[1,0,1],[0,1,0]] },
      { grid: [[0,1,0],[0,1,0],[1,0,1]] },
      { grid: [[0,0,0],[0,1,0],[1,1,1]] }
    ],
    answer: 2,
    explanation: '각 행에서 1열은 블록이 오른쪽으로 이동하는 가로 궤적을, 2열은 블록이 아래로 이동하는 세로 궤적을 그린 뒤, 두 궤적이 교차하는 지점은 소거되고 나머지가 3열이 됩니다.',
  },
  {
    id: 34,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,0,0],[1,0,0],[1,0,0]],
        [[1,1,1],[0,0,0],[0,0,0]],
        null,
        [[0,1,0],[0,1,0],[0,1,0]],
        [[0,0,0],[1,1,1],[0,0,0]],
        null,
        [[0,0,1],[0,0,1],[0,0,1]],
        [[0,0,0],[0,0,0],[1,1,1]],
        null
      ]
    },
    options: ['1', '2', '3', '4'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[0,1,1],[1,0,0],[1,0,0]] },
      { grid: [[0,1,0],[1,0,1],[0,1,0]] },
      { grid: [[0,0,1],[0,0,1],[1,1,0]] },
      { grid: [[1,1,0],[0,0,1],[0,0,1]] }
    ],
    answer: 2,
    explanation: '각 행에서 1열은 블록이 아래로 이동하는 세로 궤적을, 2열은 블록이 오른쪽으로 이동하는 가로 궤적을 그린 뒤, 두 궤적이 교차하는 지점은 소거되고 나머지가 3열이 됩니다.',
  },
  {
    id: 35,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,0,0],[0,0,0],[0,0,0]],
        [[0,1,0],[0,0,0],[0,0,0]],
        null,
        [[0,0,0],[1,1,0],[0,0,0]],
        [[0,1,0],[0,1,0],[0,0,0]],
        null,
        [[0,0,0],[0,0,0],[1,1,1]],
        [[0,1,0],[0,1,0],[0,1,0]],
        null
      ]
    },
    options: ['1', '2', '3', '4'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1,1,0],[0,0,0],[0,0,0]] },
      { grid: [[0,1,0],[1,0,0],[0,0,0]] },
      { grid: [[0,1,0],[0,1,0],[1,0,1]] },
      { grid: [[0,0,0],[0,1,0],[1,1,1]] }
    ],
    answer: 2,
    explanation: '각 행에서 1열의 블록 개수는 행 번호만큼(1, 2, 3개) 늘어나고, 2열의 블록은 가운데 세로줄에 고정됩니다. 두 궤적이 교차하는 지점은 소거되고 나머지가 3열이 됩니다.',
  },
  {
    id: 36,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'triangle', lines: ['x', 'h'] }, { frame: 'triangle', lines: ['h'] }, { frame: 'triangle', lines: ['x'] },
        { frame: 'triangle', lines: ['+', '/'] }, { frame: 'triangle', lines: ['/'] }, { frame: 'triangle', lines: ['+'] },
        { frame: 'triangle', lines: ['x', '+'] }, { frame: 'triangle', lines: ['x'] }, null
      ]
    },
    options: ['1', '2', '3', '4', '5', '6', '7', '8'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'triangle', lines: ['x'] } },
      { composite: { frame: 'triangle', lines: ['+'] } },
      { composite: { frame: 'triangle', lines: ['/'] } },
      { composite: { frame: 'triangle', lines: ['\\'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'circle', lines: ['+'] } },
      { composite: { frame: 'triangle', lines: ['h'] } },
      { composite: { frame: 'triangle', lines: ['v'] } }
    ],
    answer: 1,
    explanation: '왼쪽 도형에서 가운데 도형의 선을 빼는 차집합 규칙입니다. {x,+} \\ {x} = {+} = {h,v}.',
  },
  {
    id: 37,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['/'] }, { frame: 'square', lines: ['\\'] }, { frame: 'square', lines: ['x'] },
        { frame: 'square', lines: ['\\'] }, { frame: 'square', lines: ['x'] }, { frame: 'square', lines: ['/'] },
        { frame: 'square', lines: ['x'] }, { frame: 'square', lines: ['/'] }, null
      ]
    },
    options: ['1', '2', '3', '4', '5', '6', '7', '8'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'square', lines: ['\\'] } },
      { composite: { frame: 'square', lines: ['/'] } },
      { composite: { frame: 'square', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'circle', lines: ['\\'] } },
      { composite: { frame: 'circle', lines: ['/'] } },
      { composite: { frame: 'square', lines: ['h'] } },
      { composite: { frame: 'square', lines: ['v'] } }
    ],
    answer: 0,
    explanation: '각 행에서 / → \\ → x 순으로 선이 순환합니다. 3행 마지막은 \\ 입니다.',
  },
  {
    id: 38,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,1,1],[0,1,0],[0,0,0]],
        [[1,0,0],[1,1,1],[0,0,0]],
        null,
        [[0,0,0],[1,1,1],[0,1,0]],
        [[0,1,0],[0,1,0],[1,1,0]],
        null,
        [[0,1,0],[1,1,1],[0,0,0]],
        [[1,0,0],[1,1,0],[1,0,0]],
        null
      ]
    },
    options: ['1', '2', '3', '4'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1,0,1],[0,0,0],[0,0,0]] },
      { grid: [[0,0,1],[0,0,0],[1,0,0]] },
      { grid: [[1,0,1],[1,0,0],[1,0,1]] },
      { grid: [[1,1,1],[0,0,0],[1,1,1]] }
    ],
    answer: 2,
    explanation: '각 행에서 1열은 T자 블록을 시계방향 90° 회전시킨 모양이고, 2열은 같은 T자 블록을 반시계방향 90° 회전시킨 모양입니다. 두 모양이 겹치는 부분은 소거되고 나머지가 3열이 됩니다.',
  },
  {
    id: 39,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,0,0],[0,0,0],[0,0,0]],
        [[0,0,1],[0,0,0],[0,0,0]],
        [[1,1,0],[0,0,1],[0,0,1]],
        [[0,0,0],[1,0,0],[0,0,0]],
        [[0,1,0],[0,0,0],[0,0,0]],
        [[0,1,0],[1,0,1],[0,1,0]],
        [[0,0,0],[0,0,0],[1,0,0]],
        [[1,0,0],[0,0,0],[0,0,0]],
        null
      ]
    },
    options: ['1', '2', '3', '4'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1,0,0],[1,0,0],[0,1,1]] },
      { grid: [[1,0,0],[1,0,0],[1,1,1]] },
      { grid: [[0,0,0],[1,0,0],[0,1,1]] },
      { grid: [[1,0,0],[0,1,0],[0,1,1]] }
    ],
    answer: 0,
    explanation: '각 행에서 1열의 블록이 오른쪽으로 이동하는 궤적과 2열의 블록이 아래로 이동하는 궤적을 그린 뒤, 두 궤적이 교차하는 지점은 소거되고 나머지가 3열이 됩니다.',
  },
  {
    id: 40,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['h', 'v'] }, { frame: 'square', lines: ['v', '/'] }, { frame: 'square', lines: ['h', '/'] },
        { frame: 'square', lines: ['h', '\\'] }, { frame: 'square', lines: ['\\'] }, { frame: 'square', lines: ['h'] },
        { frame: 'square', lines: ['+', '/'] }, { frame: 'square', lines: ['/'] }, null
      ]
    },
    options: ['1', '2', '3', '4', '5', '6', '7', '8'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['/'] } },
      { composite: { frame: 'square', lines: ['\\'] } },
      { composite: { frame: 'circle', lines: ['+'] } },
      { composite: { frame: 'circle', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['h'] } },
      { composite: { frame: 'square', lines: ['v'] } }
    ],
    answer: 0,
    explanation: '왼쪽과 가운데에서 겹치는 선만 제거하는 XOR 규칙입니다. {+,/} \\ {/} = {+} = {h,v}.',
  },
  {
    id: 41,
    category: 'number',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['2', '5', '11'],
        ['23', '47', '95'],
        ['191', '383', '?']
      ]
    },
    options: ['765', '769', '767', '771'],
    answer: 2,
    explanation: '이전 수에 2를 곱하고 1을 더합니다. 383×2+1 = 767.',
  },
  {
    id: 42,
    category: 'number',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['2', '5', '10'],
        ['13', '26', '29'],
        ['58', '61', '?']
      ]
    },
    options: ['124', '120', '122', '126'],
    answer: 2,
    explanation: '+3과 ×2가 번갈아 적용됩니다. 61×2 = 122.',
  },
  {
    id: 43,
    category: 'number',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['1', '9', '25'],
        ['49', '81', '121'],
        ['169', '225', '?']
      ]
    },
    options: ['256', '324', '289', '361'],
    answer: 2,
    explanation: '홀수의 제곱 수열입니다. 17² = 289.',
  },
  {
    id: 44,
    category: 'number',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['1', '2', '3', '4'],
        ['2', '4', '6', '8'],
        ['3', '6', '9', '12'],
        ['4', '8', '12', '?']
      ]
    },
    options: ['15', '18', '16', '20'],
    answer: 2,
    explanation: '행 번호와 열 번호를 곱한 구구단 배열입니다. 4×4 = 16.',
  },
  {
    id: 45,
    category: 'number',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['1', '3', '7', '15'],
        ['2', '5', '11', '23'],
        ['3', '7', '15', '31'],
        ['4', '9', '19', '?']
      ]
    },
    options: ['37', '41', '38', '39'],
    answer: 3,
    explanation: '각 행에서 이전 수에 2를 곱하고 1을 더하는 규칙이 반복됩니다. 19×2+1 = 39.',
  },
  {
    id: 46,
    category: 'number',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['1', '1', '1', '1'],
        ['1', '2', '3', '4'],
        ['1', '3', '6', '10'],
        ['1', '4', '10', '?']
      ]
    },
    options: ['18', '20', '22', '24'],
    answer: 1,
    explanation: '각 칸이 위쪽 칸과 왼쪽 칸의 합인 파스칼 삼각형 배열입니다. 10 + 10 = 20.',
  },
  {
    id: 47,
    category: 'number',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['3', '6', '12', '24'],
        ['5', '10', '20', '40'],
        ['7', '14', '28', '56'],
        ['9', '18', '36', '?']
      ]
    },
    options: ['64', '72', '80', '88'],
    answer: 1,
    explanation: '각 행에서 2배씩 증가합니다. 36×2 = 72.',
  },
  {
    id: 48,
    category: 'number',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['1', '3', '6', '10'],
        ['2', '4', '7', '11'],
        ['3', '5', '8', '12'],
        ['4', '6', '9', '?']
      ]
    },
    options: ['12', '14', '13', '11'],
    answer: 2,
    explanation: '각 행에서 차이가 +2, +3, +4로 늘어납니다. 9 + 4 = 13.',
  },
  {
    id: 89,
    category: 'number',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['1', '4', '2'],
        ['3', '12', '6'],
        ['5', '20', '?']
      ]
    },
    options: ['8', '10', '12', '15'],
    answer: 1,
    explanation: '각 행에서 첫 수에 4를 곱하면 둘째 수가 되고, 둘째 수를 2로 나누면 셋째 수가 됩니다. 20 ÷ 2 = 10.',
  },
  {
    id: 90,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,1,0],[0,0,0],[0,0,0]],
        [[0,0,0],[0,0,1],[0,0,1]],
        [[0,0,1],[1,0,1],[1,0,0]],
        [[0,0,0],[0,1,0],[0,0,1]],
        [[1,0,0],[0,0,1],[0,0,0]],
        [[1,0,1],[0,1,0],[0,0,0]],
        [[0,0,0],[1,0,0],[1,0,0]],
        [[0,0,0],[0,0,0],[1,1,1]],
        null
      ]
    },
    options: ['1', '2', '3', '4'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1,1,1],[0,0,1],[0,0,0]] },
      { grid: [[1,1,1],[0,0,0],[0,0,0]] },
      { grid: [[1,1,0],[0,0,0],[0,1,1]] },
      { grid: [[0,0,1],[1,0,1],[0,1,0]] }
    ],
    answer: 0,
    explanation: '각 행에서 1열을 시계방향 90° 회전하고 2열을 반시계방향 90° 회전한 뒤, 겹치는 부분을 소거하는 XOR 규칙이 적용됩니다.',
  },
  {
    id: 91,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['h'] }, { frame: 'square', lines: ['v'] }, { frame: 'square', lines: ['+'] },
        { frame: 'square', lines: ['/'] }, { frame: 'square', lines: ['\\'] }, { frame: 'square', lines: ['x'] },
        { frame: 'square', lines: ['h', '/'] }, { frame: 'square', lines: ['v', '\\'] }, null
      ]
    },
    options: ['1', '2', '3', '4', '5', '6', '7', '8'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'square', lines: ['+', 'x'] } },
      { composite: { frame: 'square', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['h', 'v'] } },
      { composite: { frame: 'circle', lines: ['+', 'x'] } },
      { composite: { frame: 'circle', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['/', '\\'] } },
      { composite: { frame: 'square', lines: ['h', '/'] } }
    ],
    answer: 0,
    explanation: '왼쪽과 가운데의 모든 선을 합치는 합집합 규칙입니다. {h,/} ∪ {v,\\} = {h,v,/,\\} = {+, x}.',
  },
  {
    id: 92,
    category: 'number',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'diamond', lines: ['x', 'h'] }, { frame: 'diamond', lines: ['x', 'v'] }, { frame: 'diamond', lines: ['x'] },
        { frame: 'diamond', lines: ['+', '/'] }, { frame: 'diamond', lines: ['+', '\\'] }, { frame: 'diamond', lines: ['+'] },
        { frame: 'diamond', lines: ['h', 'v', '/'] }, { frame: 'diamond', lines: ['h', 'v', '\\'] }, null
      ]
    },
    options: ['1', '2', '3', '4', '5', '6', '7', '8'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'diamond', lines: ['x'] } },
      { composite: { frame: 'diamond', lines: ['+'] } },
      { composite: { frame: 'diamond', lines: ['/'] } },
      { composite: { frame: 'diamond', lines: ['\\'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'circle', lines: ['+'] } },
      { composite: { frame: 'diamond', lines: ['h'] } },
      { composite: { frame: 'diamond', lines: ['v'] } }
    ],
    answer: 1,
    explanation: '왼쪽과 가운데에서 겹치는 선만 남기는 교집합 규칙입니다. {h,v,/} ∩ {h,v,\\} = {h,v} = +.',
  },
];